import { request } from '@umijs/max';

/**
 * 上传图标文件
 * @param file 要上传的文件
 * @returns 返回上传结果，包含 url
 */
export async function uploadIcon(file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return request<{
    code: number;
    data: { url: string };
    message: string;
  }>('/api/common/upload', {
    method: 'POST',
    data: formData,
    skipContentType: true,
  });
}

/**
 * 通用上传方法
 * @param file 要上传的文件
 * @returns 返回上传结果
 */
export async function uploadFile(file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return request<{
    code: number;
    data: { url: string };
    message: string;
  }>('/api/common/upload', {
    method: 'POST',
    data: formData,
    skipContentType: true,
  });
}
